/* eslint-disable */
// @generated by scripts/generate-environment-pages.js. Do not edit directly.

/** Environment pages without dynamic segments, relative to the environment root. */
export const environmentStaticPages: ReadonlySet<string> = new Set([
  "",
  "adhoc-sketches",
  "admin",
  "admin-base-images",
  "admin-conversations",
  "admin-nodes",
  "admin-nodes/resource-group-service",
  "agent-builder",
  "agent-conversations",
  "agent-policies/new",
  "agent-templates",
  "agent-templates/new",
  "agents",
  "aggregations",
  "ai-traces",
  "alert-config",
  "archived-queries",
  "argo-workflows",
  "artifact-repositories",
  "background-persistence",
  "branches",
  "build-profile",
  "catalog-overview",
  "clickhouse",
  "cloud-overview",
  "compute",
  "container-snapshots",
  "dashboards",
  "dashboards/bloom-filters-overview",
  "dashboards/detailed-performance-metrics",
  "dashboards/kubernetes-nodes-overview",
  "dashboards/kubernetes-pods-overview",
  "data",
  "data-catalog",
  "data-explorer/sql",
  "data-lineage",
  "data-sources",
  "data-sources/new/configure",
  "data-sources/new/kind",
  "data-sources/offline-store",
  "data-sources/offline-store/new",
  "data-sources/online-store",
  "data-sources/online-store/edit",
  "data-sources/vector-db",
  "data-sources/vector-db/edit",
  "dataframe-runs",
  "datasets",
  "debug-shell",
  "deployments",
  "environment-variables",
  "errors",
  "errors/aggregated",
  "evaluations",
  "evaluations/compare",
  "evaluations/new",
  "external-functions",
  "external-functions/new",
  "favorites",
  "features",
  "features/wow",
  "global-metrics",
  "images",
  "incidents",
  "ingestion-health",
  "jobs",
  "kube-events",
  "kubernetes",
  "kubernetes/routes/graph",
  "logs",
  "logs/access-logs",
  "logs/audit-logs",
  "mcp-gateway",
  "mcp-gateway/connect",
  "mcp-gateway/live",
  "meta-queries",
  "metadata-cron-jobs",
  "metrics-chart",
  "metrics-database",
  "metrics-explorer",
  "metrics/debug-chart",
  "model-deployments",
  "model-gateway",
  "model-gateway/routes/new",
  "models",
  "models/training-runs-v2",
  "monitors",
  "monitors/new",
  "mql-chart",
  "nodepools",
  "notebook-kernels",
  "notebooks",
  "observability",
  "offline-queries",
  "offline-queries/resource-group-utilization",
  "offline-queries/utilization",
  "online-store-config",
  "overview",
  "perf-visualizer",
  "queries",
  "query-plans",
  "query-runs",
  "raw-metrics-explorer",
  "resolvers",
  "resolvers/graph-viz",
  "resolvers/proto",
  "resources",
  "runs",
  "sandboxes",
  "scaling-groups",
  "secrets",
  "settings",
  "settings/ai-connections",
  "settings/alert-config",
  "settings/archive",
  "settings/artifact-repositories",
  "settings/assistant",
  "settings/audit-logs",
  "settings/billing",
  "settings/buckets",
  "settings/buckets/new",
  "settings/build-profile",
  "settings/cli-login",
  "settings/clickhouse",
  "settings/cloud-overview",
  "settings/compute",
  "settings/connections",
  "settings/debug-chart",
  "settings/delete-team",
  "settings/environment-variables",
  "settings/feature-flags",
  "settings/general",
  "settings/github",
  "settings/global-metrics",
  "settings/host-capacity",
  "settings/incident-io",
  "settings/infra-pipelines",
  "settings/kubernetes",
  "settings/logstash",
  "settings/nodepools",
  "settings/notebooks",
  "settings/pager-duty",
  "settings/permissions",
  "settings/quotas",
  "settings/resource-group-jobs",
  "settings/resources",
  "settings/shared-resources",
  "settings/slack",
  "settings/snowflake",
  "settings/sso",
  "settings/suspend",
  "settings/tokens",
  "settings/trusted-ips",
  "settings/usage-dashboard",
  "settings/webhooks",
  "source-code",
  "span-sources",
  "spans",
  "sql/queries",
  "storage",
  "studio",
  "tasks",
  "tiles",
  "tiles/raw",
  "traces",
  "volumes",
  "webhooks",
  "workflow-orchestrator",
  "workflow-orchestrator-engine",
  "workflows",
]);
